<ion-card *ngIf="emp">
  <ion-row *ngIf="emp.user">
    <ion-col size="4" sizeMd="4">
    </ion-col>
    <ion-col size="4" sizeMd="4" class="textCenter">
      <!-- https://firebasestorage.googleapis.com/v0/b/allyot-ea84d.appspot.com/o/vanshavali%2FprofileImg%2F1724264943117.jpg?alt=media&token=65e60561-7e7e-439d-ac37-60d15340c3ae -->
      <app-attachment-display (onUpload)="afterUpload($event)" [(attachmentUrl)]="emp.user.url" [type]="'IMAGE'"
        [path]="'vanshavali/profileImg/'" [canEdit]="true">
      </app-attachment-display>
    </ion-col>
    <ion-col size="4" sizeMd="4">
    </ion-col>
    <ion-col size="6" sizeMd="6" class="padding5">
      <app-a-input [label]="trans.translate('Name')" [validations]="['mandatory',toastService.checkValidation,'name']"
        [validationObject]="emp.user" [(variable)]="emp.user.name"></app-a-input>
    </ion-col>

    <ion-col size="6" sizeMd="6" class="padding5">
      <app-a-input [label]="trans.translate('SurName')" [(variable)]="emp.user.last_name"></app-a-input>
    </ion-col>

    <ion-col size="12" sizeMd="12" class="padding5" *ngIf="auth.business.category">
      <app-a-select [label]="trans.translate('Sub Community/Gotra/Khap/Pur')"
        [(variable)]="emp.user.user_pd.sub_community" [objectList]="auth.business.category"></app-a-select>
    </ion-col>

    <ion-col size="12" sizeMd="12" class="margin5px padding5" style="display: flex;" *ngIf="showMarital">
      <div class="borderMedium padding5">
        {{'Marital Status' | translate}} *
      </div>
      <div class="borderMedium padding5 genderColumn" (click)="emp.user.user_pd.marital='Married'">
        {{'Married'| translate}}
        <ion-badge class="font0_8 padding5 margin2px" color="tertiary"
          *ngIf="emp.user.user_pd.marital=='Married'">M</ion-badge>
        <ion-badge class="font0_8 padding5 margin2px" color="medium"
          *ngIf="emp.user.user_pd.marital!='Married'">M</ion-badge>
      </div>
      <div class="borderMedium padding5 genderColumn" (click)="emp.user.user_pd.marital='UnMarried'">
        {{'UnMarried' | translate}}
        <ion-badge class="font0_8 padding5 margin2px" color="medium"
          *ngIf="emp.user.user_pd.marital!='UnMarried'">S</ion-badge>
        <ion-badge class="font0_8 padding5 margin2px" color="danger"
          *ngIf="emp.user.user_pd.marital=='UnMarried'">S</ion-badge>
      </div>
    </ion-col>

    <ion-col size="8" sizeMd="6" class="padding5">
      <app-date [label]="trans.translate('Birth Date')+ ' *'" [(model)]="emp.user.dob" [minDate]="'1800-01-01'"
        [maxDate]="maxDate" (modelChange)="onDobChange($event)"></app-date>
    </ion-col>

    <ion-col size="4" sizeMd="6" class="padding5">
      <app-a-input [label]="trans.translate('Age')" type="number" [(variable)]="age"
        (variableChange)="onAgeChange($event)">
      </app-a-input>
    </ion-col>

    <ion-col size="12" class="padding10">
      <input class="padding5" type="checkbox" [(ngModel)]="isLive" />
      <span class="padding5">{{'Is the person Alive?'|translate}}</span>
    </ion-col>
    <ion-col size="12" sizeMd="6" class="padding5" *ngIf="!isLive">
      <app-date [label]="trans.translate('Date of Death')" [(model)]="emp.user.user_pd.death_date" [minDate]="minDate"
        [maxDate]="maxDate"></app-date>
    </ion-col>

    <ion-col size="12" sizeMd="12" class="padding5">
      <app-pincode [(variable)]="emp.user.user_pd"></app-pincode>
    </ion-col>

    <ion-col size="12" sizeMd="6" class="padding5">
      <app-a-input [label]="trans.translate('Place of Origin')+ ' *'"
        [(variable)]="emp.user.user_pd.origin_city"></app-a-input>
    </ion-col>
    <ion-col size="12" sizeMd="6" class="padding5">
      <ion-row>
        <ion-col size="5">
          <app-a-select [label]="'Code'" [(variable)]="emp.user.user_pd.country_code"
            [objectList]="countryService.countries" [type]="'Object'" [value]="'code'"
            [display]="'displayLabel'"></app-a-select>
        </ion-col>
        <ion-col size="7">
          <app-a-input [label]="trans.translate('Mobile')" [(variable)]="emp.user.user_pd.mobile"
            (onBlur)="onBlurMobile()"></app-a-input>
        </ion-col>
      </ion-row>
    </ion-col>
    <div class="padding10">{{'This number just helps us avoid duplicate relative entries.'|translate}} </div>
  </ion-row>
</ion-card>